module.exports = __webpack_public_path__ + "static/media/DSCF2412-6.5d1d0f36.jpg";